import styled from 'styled-components';

export const PaginationContainer = styled.div`
    display: flex;
    gap: 0.5rem;
    justify-content: center;
    align-items: center;
    margin: 1rem 0;
    flex-wrap: wrap;

    button {
        padding: 0.4rem 0.8rem;
        border: 1px solid var(--border);
        background: var(--surface-2);
        color: var(--text);
        cursor: pointer;
        border-radius: 4px;
        transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;

        &:hover:not(:disabled) {
            border-color: var(--accent);
            color: var(--accent);
        }

        &:disabled {
            opacity: 0.45;
            cursor: not-allowed;
        }
    }

    span {
        padding: 0 0.5rem;
        color: var(--text);
    }
`;
